// src/axiosInstance.js
import axios from 'axios';
import { handleForceLogout, isSessionForceLogoutMessage, consumeForceLogoutAcknowledgment } from '../forceLogout';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add a function to attach interceptors
export const injectTokenInterceptor = (store) => {
    // Request interceptor
    api.interceptors.request.use(config => {
        const state = store.getState();
        const token = state.VisitorReducer?.token || state.Auth?.token;
        if (token) {
            config.headers.Authorization = `${token}`;
        }
        return config;
    });

    // Response interceptor
    api.interceptors.response.use(
        res => res,
        err => {
            const msg = err?.response?.data?.message;
            if (
                err.response?.status === 401 &&
                isSessionForceLogoutMessage(msg)
            ) {
                if (consumeForceLogoutAcknowledgment()) {
                    return Promise.reject(err);
                }
                handleForceLogout(msg, { dispatch: store.dispatch });
            }
            return Promise.reject(err);
        }
    );
};

export default api;